import { FaHome, FaHandsHelping, FaCouch } from 'react-icons/fa';
import { RiCurrencyFill } from "react-icons/ri";
import { useTr } from '../lib/i18n';

const Servicii = () => {
  const tr = useTr();
  return (
    <section className="py-[60px] sm:py-[80px] px-[12px] flex flex-col gap-[15px] justify-between sm:container sm:mx-auto text-center">
      <p className="text-[14px] font-body font-[500] text-[#d5ab63] uppercase  ">
        {tr('Tipuri de servicii', 'Виды услуг')}
      </p>
      <h2 className="text-[28px] xs:text-[32px] lg:text-[40px] font-heading font-[500] mb-16">
        {tr('Hai să găsim împreună', 'Давайте вместе найдём')} <br className="hidden md:block" /> {tr('proprietatea potrivită pentru tine', 'подходящую для вас недвижимость')}
      </h2>

      <div className="grid gap-8 cstmvv:grid-cols-2 cstmvv:grid-rows-2 max-w-6xl mx-auto font-body">
        <div className="bg-[#ececec] rounded-[5px] p-8 text-left hover:shadow-lg transition duration-100 ease-in">
          <div className="bg-[#d5ab63] w-14 h-14 flex items-center justify-center rounded-full mb-4">
            <FaHome className="text-white text-2xl" />
          </div>
          <h4 className="text-lg font-semibold mb-2">{tr('Soluții rapide', 'Быстрые решения')}<br />{tr('pentru vânzarea ta', 'для вашей продажи')}</h4>
          <p className="text-sm text-gray-600">
            {tr(
              'Evaluare corectă, promovare inteligentă și sprijin complet pentru a vinde în siguranță și la cel mai bun preț.',
              'Справедливая оценка, грамотное продвижение и полная поддержка, чтобы продать безопасно и по лучшей цене.'
            )}
          </p>
        </div>

        <div className="bg-[#ececec] rounded-[5px] p-8 text-left hover:shadow-lg transition duration-100 ease-in">
          <div className="bg-[#d5ab63] w-14 h-14 flex items-center justify-center rounded-full mb-4">
            <FaHandsHelping className="text-white text-2xl" />
          </div>
          <h4 className="text-lg font-semibold mb-2">{tr('Ghidare completă', 'Полное сопровождение')}<br />{tr('la cumpărare', 'при покупке')}</h4>
          <p className="text-sm text-gray-600">
            {tr(
              'Te ajutăm să alegi corect: consultanță personalizată, vizionări rapide și sprijin pe tot parcursul procesului.',
              'Поможем сделать правильный выбор: персональные консультации, быстрые просмотры и поддержка на всех этапах.'
            )}
          </p>
        </div>

        <div className="bg-[#ececec] rounded-[5px] p-8 text-left hover:shadow-lg transition duration-100 ease-in">
          <div className="bg-[#d5ab63] w-14 h-14 flex items-center justify-center rounded-full mb-4">
            <RiCurrencyFill className="text-white text-2xl" />
          </div>
            <h4 className="text-lg font-semibold mb-2">{tr('Bonus special', 'Специальный бонус')}<br />{tr('la credit ipotecar', 'по ипотечному кредиту')}</h4>
            <p className="text-sm text-gray-600">
              {tr(
                'Primești 100 € rambursabili la achiziția locuinței prin credit ipotecar — un avantaj suplimentar pentru o decizie inspirată.',
                'Получите 100 € к возврату при покупке жилья в ипотеку — дополнительное преимущество для верного решения.'
              )}
            </p>
        </div>

        <div className="bg-[#ececec] rounded-[5px] p-8 text-left hover:shadow-lg transition duration-100 ease-in">
          <div className="bg-[#d5ab63] w-14 h-14 flex items-center justify-center rounded-full mb-4">
            <FaCouch className="text-white text-2xl" />
          </div>
          <h4 className="text-lg font-semibold mb-2">{tr('Găsim locuința', 'Найдём жильё')}<br />{tr('perfectă pentru tine', 'идеально подходящее вам')}</h4>
          <p className="text-sm text-gray-600">
            {tr(
              'Apartamente, case sau terenuri – avem opțiuni variate și te ajutăm să o alegi pe cea care ți se potrivește.',
              'Квартиры, дома или участки — у нас разнообразные варианты, и мы поможем выбрать подходящий.'
            )}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Servicii;
